/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { BTree } from "@tylerbu/sorted-btree-es6";
export function newGenericChangeset(nodes = []) {
    return new BTree(nodes);
}
//# sourceMappingURL=genericFieldKindTypes.js.map